import React, { useState } from 'react'
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, IconButton, Tooltip } from '@mui/material'


export default function ExpandableCard({title,children,defaultOpen=true}) {
    const [expandBusinessHours,setExpandBusinessHours] = useState(defaultOpen);

    return (
        <>
            <div className="card">
                <div className="card-header">
                    <span className="float-start"> {title} </span>
                    <span className="float-end">                         
                            <IconButton onClick={()=>setExpandBusinessHours(state => !state)} className="p-0">
                                {expandBusinessHours ? <ExpandLess />  : <ExpandMore /> }
                            </IconButton>
                    </span>
                </div>
                <Collapse in={expandBusinessHours} timeout="auto" unmountOnExit >
                        {children}
                </Collapse>
            </div>
        </>
    
  )
}
